module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "kp-btn-action-sm kp-btn__danger",
    on: {
      "click": function($event) {
        return _vm.jumpRemoveOptionId({
          jump: _vm.jump,
          index: _vm.index
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-f69a31e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/buttons/RemoveOption.vue
 ** module id = 926
 ** module chunks = 1
 **/